// Home.js
import React from "react";
import Navbar from "../Navbar";
import Footer from "../Footer";
import PhotoGallery from "../components/Gallary";

const Work = () => {
  return (
    <>
      <Navbar />
      <PhotoGallery />
      <Footer />
    </>
  );
};

export default Work;
